import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {retry, timer} from 'rxjs';

export const networkRetryInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    retry({
      count: 3,
      delay: (error: any, retryCount: number) => {
        if (error instanceof HttpErrorResponse && error.status === 0) {
          console.warn(`[Retry Interceptor] Problema di rete. Tentativo ${retryCount} di 3...`);
          return timer(Math.pow(2, retryCount - 1) * 1000);
        }

        throw error;
      }
    })
  );
};
